import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { FuelType } from "@/interfaces";
import { errorHandler } from "@/lib/utils";
import { fuelTypeService } from "@/services/api/fuelTypes";
import { useEffect, useState } from "react";

interface FuelTypesSelectProps {
  value?: number;
  onChange: (value: number) => void;
}

const FuelTypesSelect = ({ value, onChange }: FuelTypesSelectProps) => {
  const [fuelTypes, setFuelTypes] = useState<FuelType[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadFuelTypes = async () => {
      try {
        setLoading(true);

        const response = await fuelTypeService.index();

        const transformedFuelTypes = response.data.map((fuelType) => ({
          ...fuelType,
          fuel_type_id: fuelType.id,
        }));

        setFuelTypes(transformedFuelTypes);
      } catch (err) {
        errorHandler(err, "Erro ao carregar tipos de combustível.");
      } finally {
        setLoading(false);
      }
    };

    loadFuelTypes();
  }, []);

  return (
    <Select
      disabled={loading}
      value={value?.toString()}
      onValueChange={(val) => onChange(Number(val))}
    >
      <SelectTrigger className="w-full">
        <SelectValue
          placeholder={
            loading
              ? "Carregando tipos de combustível..."
              : "Selecione um tipo de combustível"
          }
        />
      </SelectTrigger>
      <SelectContent>
        {fuelTypes.map((fuelType) => (
          <SelectItem key={fuelType.id} value={fuelType.id.toString()}>
            {fuelType.name}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
};

export default FuelTypesSelect;
